/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC} from 'react'
import {Redirect, Switch, Route} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout} from '../modules/auth'
import {AuthPage2} from '../modules/auth/AuthPage2'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {RootState} from '../../setup'
import {PublicJobPage} from '../pages/public/job/PublicJobPage'
import {PublicJobApplyPage} from '../pages/public/job/PublicJobApplyPage'
import {PublicCompanyPage} from '../pages/public/company/PublicCompanyPage'
import {PUBLIC_JOB_PATH} from '../pages/hr/job/JobModel'
import {PUBLIC_COMPANY_PATH} from '../pages/public/PublicModels'

const Routes: FC = () => {
  const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  
  return (
    <Switch>
      {/* Giriş gerektirmeyen kariyer sayfaları; oturum durumundan bağımsız, layout'suz açılır */}
      <Route path={`${PUBLIC_COMPANY_PATH}/:slug`} component={PublicCompanyPage} />
      <Route path={`${PUBLIC_JOB_PATH}/:id/apply`} component={PublicJobApplyPage} />
      <Route path={`${PUBLIC_JOB_PATH}/:id`} component={PublicJobPage} />

      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage2 />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from='/login' to='/' />
      )}

      <Route path='/error' component={ErrorsPage} />
      <Route path='/logout' component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/login` when user is not authorized*/
        <Redirect to='/login' />
      ) : (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}
      
    </Switch>
  )
}

export {Routes}
